import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AppService} from './app.service';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import UIkit from 'uikit';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(
    private router: Router,
    private appService: AppService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        data = {
          reason: error && error.error && error.error.reason ? error.error.reason : '',
          status: error.status
        };


        if (error.status === 401) {
          localStorage.removeItem('accessToken');
          this.router.navigate(['/']);
          UIkit.modal('#modal-center').show();
        }

        // if (error.status === 500) {
        //   this.router.navigate(['/error']);
        // }


        return throwError(error);
      }));
  }
}

